import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/auctions";
import type { ResponseConfig } from "@/api/client/auctions";
import type { SelectAuctionWinnersMutationRequest, SelectAuctionWinnersMutationResponse, SelectAuctionWinnersQueryParams, SelectAuctionWinners400, SelectAuctionWinners403 } from "../types/SelectAuctionWinners";

/**
 * @description Метод предназначен для подтверждения выбора победителей в запросе.  Предполагает выбор ставок-победителей по запросу для дальнейшего создания по ним заявок на продажу. https://confluence.poleinvest.ru/pages/viewpage.action?pageId=463899702

 * @link /v1/auction/do_select-winners
 */

export function useSelectAuctionWinners <TData = SelectAuctionWinnersMutationResponse, TError = SelectAuctionWinners400 | SelectAuctionWinners403, TVariables = SelectAuctionWinnersMutationRequest>(params: SelectAuctionWinnersQueryParams, options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/v1/auction/do_select-winners`,
        data,
        params,
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
